<div fxLayout="column" fxFlex="100">
  <div fxLayout="row" fxLayoutAlign="space-between start">
      <h1 mat-dialog-title class="m-10">{{'MODAL_CONSULT_INFRAESTRU.TITL' | translate}}</h1>
      <button mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
      </button>
    </div>
    <div class="" fxLayout="column" fxFlex="100" >
      <div fxLayout="column" fxLayoutAlign="start center">
        <p>{{'MODAL_CONSULT_INFRAESTRU.INSTRUC_1' | translate}}</p>
        <span class="ml-25"> <b class="fz-20">{{'MODAL_CONSULT_INFRAESTRU.NO' | translate}}</b><mat-slide-toggle class="ml-10"  [(ngModel)]="infraEstruct"></mat-slide-toggle><b class="ml-10 fz-20">{{'MODAL_CONSULT_INFRAESTRU.SI' | translate}}</b></span>
      </div>
      <div class="" fxLayout="row" fxLayoutAlign="center center" *ngIf="infraEstruct">
        <div class="" fxLayout="column" fxFlex="50">
          <mat-form-field appearance="outline">
            <mat-label>{{'MODAL_CONSULT_INFRAESTRU.LAB_SUBDOMINIO' | translate}}</mat-label>
            <input matInput placeholder="Ingresa el SubDominio" [(ngModel)]="subDominio" maxlength="20" (keyup)="validacionSubDominio($event)">
            <mat-icon matSuffix>public</mat-icon>
          </mat-form-field>
          <b style="color:red;" *ngIf="caracteresNoPermitidosEmpresa">{{'MODAL_CONSULT_INFRAESTRU.WARN_CARACT' | translate}}</b>
          <!-- <b style="color:red;" *ngIf="caracteresNoPermitidosEmpresa">  {{'LOGIN.FORM.VAL.CARACT_EMA' | translate}}</b> -->
        </div>
    <p class="ml-25"  style="margin-bottom:50px"><b>{{subDominio}}</b>.culturalgo.com</p>
      </div>


    </div>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
      <button mat-raised-button (click)="saveSubDominio();">{{'MODAL_CONSULT_INFRAESTRU.BTN_CONTI' | translate}}</button>
    </div>
</div>
